import React from 'react';
import { AppNordCard } from '@/components/ui/AppNordCard'; // Assuming Nord Card wrapper

interface InsuranceInfoProps {
  // Accept insurance data as props
  insuranceProvider: string | null | undefined;
  insuranceNumber: string | null | undefined;
  // Add onEdit callback if needed
  // onEdit?: () => void;
}

const InsuranceInfo: React.FC<InsuranceInfoProps> = ({
  insuranceProvider,
  insuranceNumber,
  // onEdit
}) => {
  // TODO: Add state and form fields for editing functionality later

  return (
    <AppNordCard>
      <div className="flex justify-between items-center mb-4">
        <h4 className="nord-heading-m">Insurance Information</h4>
        {/* Add edit button if implementing editing */}
        {/* <AppNordButton variant="secondary" size="s" onClick={onEdit}>Edit</AppNordButton> */}
      </div>
      {insuranceProvider || insuranceNumber ? (
        <div className="space-y-2">
          <div>
            <p className="text-sm text-[var(--text-secondary)]">Provider</p>
            <p className="text-[var(--text-primary)] font-medium">
              {insuranceProvider || 'Not provided'}
            </p>
          </div>
          <div>
            <p className="text-sm text-[var(--text-secondary)]">Policy Number</p>
            <p className="text-[var(--text-primary)] font-medium">
              {insuranceNumber || 'Not provided'}
            </p>
          </div>
          {/* TODO: Add fields for group number, dates, etc. if needed */}
        </div>
      ) : (
        <p className="text-[var(--text-secondary)]">
          No insurance information provided.
          {/* Add a button to prompt adding info if needed */}
        </p>
      )}
    </AppNordCard>
  );
};

export default InsuranceInfo; 